import { RouteLocationNormalized } from 'vue-router';
import { useUserStore } from '~/stores/user';

class Admin implements Middleware {
    name() {
        return 'admin';
    }

    async run(to: RouteLocationNormalized) {
        const userStore = useUserStore();

        if (!userStore.data?.rootAdmin && !userStore.data?.supportOp) {
            // TODO: this should be a 403 instead
            return {
                name: '404',
                params: {
                    catchAll: location.pathname.substring(1).split('/'),
                },
                query: to.query,
                hash: to.hash,
            };
        }
    }
}

export default new Admin();
